/** DESSINS — cinq illustrations au trait, aux couleurs de la DA.
 *  Pas de bibliothèque, pas d'image à télécharger : du SVG dessiné à la main, qui prend
 *  automatiquement l'accent du thème (var(--accent)) et reste net sur tous les écrans.
 *  Elles ne bougent pas : elles racontent, elles ne distraient pas. */
import React from "react";

const TRAIT = {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  vectorEffect: "non-scaling-stroke",
};

const A = "var(--accent)";
const DOUX = "var(--accent-soft)";
const PALE = "var(--text-subtle)";
const PAPIER = "var(--surface)";

function Cadre({ children, testid, titre }) {
  return (
    <svg
      viewBox="0 0 400 300"
      role="img"
      aria-label={titre}
      data-testid={testid}
      className="w-full h-auto"
      style={{ overflow: "visible" }}
    >
      {children}
    </svg>
  );
}

/** Les DM remplacés par un seul lien. */
export function DessinLien({ testid = "dessin-lien" }) {
  return (
    <Cadre testid={testid} titre="Des dizaines de messages remplacés par un seul lien de réservation">
      {/* la pile de messages, de guingois */}
      <g transform="rotate(-7 96 96)">
        <rect x="18" y="34" width="132" height="52" rx="18" fill={PAPIER} stroke={PALE} strokeWidth="1.5" {...TRAIT} />
        <path d="M34 52h84M34 66h52" stroke={PALE} strokeWidth="1.5" {...TRAIT} />
        <path d="M40 86l-6 16 20-16" fill={PAPIER} stroke={PALE} strokeWidth="1.5" {...TRAIT} />
      </g>
      <g transform="rotate(5 96 130)">
        <rect x="30" y="104" width="118" height="46" rx="16" fill={PAPIER} stroke={PALE} strokeWidth="1.5" {...TRAIT} />
        <path d="M46 120h72M46 133h40" stroke={PALE} strokeWidth="1.5" {...TRAIT} />
      </g>
      <g transform="rotate(-3 96 190)">
        <rect x="20" y="166" width="126" height="46" rx="16" fill={PAPIER} stroke={PALE} strokeWidth="1.5" {...TRAIT} />
        <path d="M36 182h78M36 195h46" stroke={PALE} strokeWidth="1.5" {...TRAIT} />
      </g>
      {/* barré : on ne trie plus rien */}
      <path d="M14 226l142-8" stroke={PALE} strokeWidth="1.5" strokeDasharray="5 7" {...TRAIT} />
      <circle cx="150" cy="30" r="12" fill={PAPIER} stroke={PALE} strokeWidth="1.5" {...TRAIT} />
      <path d="M145 25l10 10m0-10l-10 10" stroke={PALE} strokeWidth="1.6" {...TRAIT} />

      {/* le flux vers le lien */}
      <path d="M164 122c26-6 34 12 52 12" stroke={A} strokeWidth="1.6" strokeDasharray="4 6" {...TRAIT} />
      <path d="M210 128l8 6-9 5" stroke={A} strokeWidth="1.6" {...TRAIT} />

      {/* le téléphone, la page, le lien */}
      <rect x="238" y="36" width="132" height="228" rx="26" fill={PAPIER} stroke={A} strokeWidth="1.8" {...TRAIT} />
      <path d="M286 50h36" stroke={A} strokeWidth="2.4" {...TRAIT} />
      <rect x="256" y="70" width="96" height="30" rx="15" fill={DOUX} stroke={A} strokeWidth="1.4" {...TRAIT} />
      <path d="M272 85h8m8 0h8m8 0h20" stroke={A} strokeWidth="1.6" {...TRAIT} />
      <circle cx="266" cy="85" r="4.5" fill="none" stroke={A} strokeWidth="1.4" {...TRAIT} />
      <rect x="256" y="116" width="96" height="34" rx="12" fill="none" stroke={PALE} strokeWidth="1.4" {...TRAIT} />
      <path d="M270 128h44M270 140h26" stroke={PALE} strokeWidth="1.5" {...TRAIT} />
      <rect x="256" y="160" width="96" height="34" rx="12" fill={DOUX} stroke={A} strokeWidth="1.5" {...TRAIT} />
      <path d="M270 172h44M270 184h26" stroke={A} strokeWidth="1.5" {...TRAIT} />
      <rect x="256" y="212" width="96" height="30" rx="15" fill={A} />
      <path d="M291 227l6 6 12-13" stroke={PAPIER} strokeWidth="2" {...TRAIT} />
    </Cadre>
  );
}

/** La clientèle rassemblée et protégée. */
export function DessinClientele({ testid = "dessin-clientele" }) {
  return (
    <Cadre testid={testid} titre="Ta clientèle rassemblée et protégée">
      {/* l'arche : ce qui abrite */}
      <path d="M42 236V150c0-84 44-124 116-124s116 40 116 124v86" stroke={A} strokeWidth="1.8" {...TRAIT} />
      <path d="M64 236V152c0-70 34-104 94-104s94 34 94 104v84" stroke={A} strokeWidth="1.3" strokeDasharray="4 7" opacity="0.7" {...TRAIT} />
      {/* la serrure, en clé de voûte : ce qui est à toi le reste */}
      <circle cx="158" cy="44" r="16" fill={DOUX} stroke={A} strokeWidth="1.7" {...TRAIT} />
      <circle cx="158" cy="40" r="4.5" fill="none" stroke={A} strokeWidth="1.5" {...TRAIT} />
      <path d="M155 47h6l2 8h-10z" fill="none" stroke={A} strokeWidth="1.5" {...TRAIT} />

      {/* trois fiches clientes */}
      {[
        [76, 140],
        [128, 122],
        [180, 140],
      ].map(([x, y], i) => (
        <g key={x}>
          <rect x={x} y={y} width="62" height="90" rx="14" fill={PAPIER} stroke={i === 1 ? A : PALE} strokeWidth={i === 1 ? 1.8 : 1.4} {...TRAIT} />
          <circle cx={x + 31} cy={y + 28} r="13" fill={i === 1 ? DOUX : "none"} stroke={i === 1 ? A : PALE} strokeWidth="1.4" {...TRAIT} />
          <path d={`M${x + 14} ${y + 56}h34m-34 12h22m-22 12h28`} stroke={i === 1 ? A : PALE} strokeWidth="1.4" {...TRAIT} />
        </g>
      ))}

      {/* le sol */}
      <path d="M28 236h304" stroke={PALE} strokeWidth="1.5" {...TRAIT} />
      <path d="M300 258c14-8 30-8 44 0" stroke={PALE} strokeWidth="1.4" strokeDasharray="4 6" {...TRAIT} />
      {/* une feuille, posée au sol, pour la douceur */}
      <g transform="translate(0 34)">
        <path d="M300 200c22-4 34-18 34-38-22 2-34 16-34 38z" fill={DOUX} stroke={A} strokeWidth="1.5" {...TRAIT} />
        <path d="M334 162c-14 8-24 20-30 34" stroke={A} strokeWidth="1.3" {...TRAIT} />
      </g>
    </Cadre>
  );
}

/** L'argent, enfin lisible. */
export function DessinArgent({ testid = "dessin-argent" }) {
  return (
    <Cadre testid={testid} titre="Tes revenus enfin lisibles, prestation par prestation">
      {/* le cadre du graphique */}
      <path d="M52 44v190h296" stroke={PALE} strokeWidth="1.6" {...TRAIT} />
      <path d="M52 190h296M52 140h296M52 90h296" stroke={PALE} strokeWidth="1.2" strokeDasharray="3 8" opacity="0.7" {...TRAIT} />

      {/* les barres : ce que chaque prestation rapporte vraiment */}
      {[
        [76, 160, PAPIER, PALE],
        [126, 116, DOUX, A],
        [176, 74, DOUX, A],
        [226, 128, PAPIER, PALE],
      ].map(([x, y, fond, trait]) => (
        <rect key={x} x={x} y={y} width="42" height={234 - y} rx="12" fill={fond} stroke={trait} strokeWidth="1.6" {...TRAIT} />
      ))}

      {/* la courbe qui monte */}
      <path d="M68 196c42-6 70-40 108-58s70-24 112-52" stroke={A} strokeWidth="1.8" {...TRAIT} />
      <path d="M276 82l12 4-3 12" stroke={A} strokeWidth="1.8" {...TRAIT} />

      {/* les pièces, posées sur la ligne */}
      <g>
        <ellipse cx="332" cy="228" rx="26" ry="10" fill={PAPIER} stroke={A} strokeWidth="1.5" {...TRAIT} />
        <ellipse cx="332" cy="215" rx="26" ry="10" fill={PAPIER} stroke={A} strokeWidth="1.5" {...TRAIT} />
        <ellipse cx="332" cy="202" rx="26" ry="10" fill={DOUX} stroke={A} strokeWidth="1.6" {...TRAIT} />
        <path d="M336 197c-6 0-9 2-9 5s3 5 9 5m-9-5h10" stroke={A} strokeWidth="1.5" {...TRAIT} />
      </g>

      {/* l'étiquette d'euros */}
      <rect x="64" y="26" width="86" height="30" rx="15" fill={DOUX} stroke={A} strokeWidth="1.5" {...TRAIT} />
      <path d="M92 36c-7 0-11 3-11 8s4 8 11 8m-12-8h13" stroke={A} strokeWidth="1.6" {...TRAIT} />
      <path d="M112 41h22" stroke={A} strokeWidth="1.6" {...TRAIT} />
    </Cadre>
  );
}

/** La marque et les visuels : Brand Auto + Kit Instagram. */
export function DessinImage({ testid = "dessin-image" }) {
  return (
    <Cadre testid={testid} titre="Ta palette tirée de tes photos et tes visuels Instagram prêts à poster">
      {/* deux photos du studio */}
      <g transform="rotate(-6 90 108)">
        <rect x="26" y="52" width="112" height="92" rx="16" fill={PAPIER} stroke={PALE} strokeWidth="1.5" {...TRAIT} />
      </g>
      <rect x="40" y="66" width="112" height="92" rx="16" fill={PAPIER} stroke={A} strokeWidth="1.8" {...TRAIT} />
      <circle cx="70" cy="94" r="10" fill={DOUX} stroke={A} strokeWidth="1.4" {...TRAIT} />
      <path d="M50 140c14-22 26-22 38 0m4 0c10-18 20-24 34-10" stroke={A} strokeWidth="1.5" {...TRAIT} />

      {/* la palette qu'on en tire */}
      <rect x="34" y="188" width="128" height="52" rx="18" fill={PAPIER} stroke={A} strokeWidth="1.7" {...TRAIT} />
      <circle cx="60" cy="214" r="12" fill={A} />
      <circle cx="90" cy="214" r="12" fill={DOUX} stroke={A} strokeWidth="1.3" {...TRAIT} />
      <circle cx="120" cy="214" r="12" fill="none" stroke={A} strokeWidth="1.3" {...TRAIT} />
      <path d="M140 208h10m-10 12h6" stroke={A} strokeWidth="1.5" {...TRAIT} />
      <path d="M96 158v22" stroke={A} strokeWidth="1.5" strokeDasharray="4 6" {...TRAIT} />

      {/* le visuel de story, prêt à poster */}
      <path d="M176 150c22-4 30-22 52-24" stroke={A} strokeWidth="1.6" strokeDasharray="4 6" {...TRAIT} />
      <path d="M220 120l8 6-9 5" stroke={A} strokeWidth="1.6" {...TRAIT} />
      <rect x="244" y="30" width="128" height="240" rx="22" fill={DOUX} stroke={A} strokeWidth="1.8" {...TRAIT} />
      <path d="M268 66h58m-58 18h80" stroke={A} strokeWidth="2" {...TRAIT} />
      <rect x="268" y="108" width="80" height="26" rx="13" fill={PAPIER} stroke={A} strokeWidth="1.4" {...TRAIT} />
      <path d="M282 121h30m10 0h14" stroke={A} strokeWidth="1.5" {...TRAIT} />
      <rect x="268" y="146" width="80" height="26" rx="13" fill={PAPIER} stroke={A} strokeWidth="1.4" {...TRAIT} />
      <path d="M282 159h30m10 0h14" stroke={A} strokeWidth="1.5" {...TRAIT} />
      <rect x="268" y="214" width="80" height="28" rx="14" fill={A} />
      <path d="M286 228h44" stroke={PAPIER} strokeWidth="2" {...TRAIT} />
      {/* l'étincelle : c'est déjà prêt */}
      <path d="M362 178v18m-9-9h18" stroke={A} strokeWidth="1.6" {...TRAIT} />
    </Cadre>
  );
}

/** La journée qui se remplit toute seule. */
export function DessinCalendrier({ testid = "dessin-calendrier" }) {
  return (
    <Cadre testid={testid} titre="Un agenda qui se remplit tout seul">
      {/* le calendrier */}
      <rect x="46" y="52" width="234" height="200" rx="22" fill={PAPIER} stroke={A} strokeWidth="1.8" {...TRAIT} />
      <path d="M46 100h234" stroke={A} strokeWidth="1.6" {...TRAIT} />
      <path d="M100 34v30M226 34v30" stroke={A} strokeWidth="2.2" {...TRAIT} />
      <path d="M70 78h26m20 0h58" stroke={A} strokeWidth="1.5" {...TRAIT} />

      {/* les créneaux : deux pris, un libre, un pris */}
      {[
        [70, 118, true],
        [70, 158, false],
        [70, 198, true],
      ].map(([x, y, pris]) => (
        <g key={y}>
          <rect
            x={x}
            y={y}
            width="186"
            height="30"
            rx="12"
            fill={pris ? DOUX : "none"}
            stroke={pris ? A : PALE}
            strokeWidth={pris ? 1.6 : 1.3}
            strokeDasharray={pris ? undefined : "5 6"}
            {...TRAIT}
          />
          {pris ? (
            <>
              <circle cx={x + 20} cy={y + 15} r="8" fill={PAPIER} stroke={A} strokeWidth="1.4" {...TRAIT} />
              <path d={`M${x + 38} ${y + 15}h74`} stroke={A} strokeWidth="1.6" {...TRAIT} />
              <path d={`M${x + 152} ${y + 15}h20`} stroke={A} strokeWidth="1.6" {...TRAIT} />
            </>
          ) : (
            <path d={`M${x + 84} ${y + 15}h18m-9-9v18`} stroke={PALE} strokeWidth="1.5" {...TRAIT} />
          )}
        </g>
      ))}

      {/* la pastille de confirmation, en débord */}
      <circle cx="296" cy="86" r="30" fill={PAPIER} stroke={A} strokeWidth="1.8" {...TRAIT} />
      <path d="M283 86l9 9 18-19" stroke={A} strokeWidth="2.2" {...TRAIT} />
      <path d="M330 60c8-6 14-6 22 0" stroke={A} strokeWidth="1.4" strokeDasharray="4 6" {...TRAIT} />

      {/* l'horloge, en bas */}
      <circle cx="308" cy="212" r="26" fill={DOUX} stroke={A} strokeWidth="1.6" {...TRAIT} />
      <path d="M308 196v18h13" stroke={A} strokeWidth="1.8" {...TRAIT} />
    </Cadre>
  );
}
